export const selfieTypes = [
    { input: "selfie con sonrisa", type: "SS" },
    { input: "selfie con ojos cerrados", type: "SCE" },
    // { input: "selfie con guiño izquierdo", type: "SBL" },
    // { input: "selfie con guiño derecho", type: "SBR" }
  ];

export const NEUTRAL_SELFIE = 'neutralSelfie';
export const SPECIAL_SELFIE = 'specialSelfie';
export const CAMERA_TYPE_FRONT = 'front';
export const CAMERA_TYPE_BACK = 'back';
export const DNI_FRONT = 'frente';
export const DNI_BACK = 'dorso';

//error
export const CAMERA_ACCESS_ERROR='Camera access';